/* eslint-disable jsx-a11y/anchor-is-valid */
import "./App.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Presskit from "./components/DigitalPressKit";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import UpcomingShows from "./components/UpcomingShows";
import AboutSection from "./components/AboutUs";
import BookingSection from "./components/BookingSection";
import Footer from "./components/Footer";
import WaitlistModal from "./components/WaitlistModal";
import Merch from "./components/MerchPage";
import LegalPage from "./components/store/LegalPage";
import Discography from "./components/Discography";
import ComingSoon from "./components/ComingSoon";
import { trackCampaignHit } from "./trackCampaign";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showWaitlist, setShowWaitlist] = useState(false);
  const [currentPage, setCurrentPage] = useState("home");
  const [legalKind, setLegalKind] = useState("terms");

  useEffect(() => {
    trackCampaignHit();
  }, []);

  // Handle routing
  useEffect(() => {
    // Cloudflare Pages 308-redirects "/presskit" (and other prerendered
    // routes) to "/presskit/" before serving the static file, so the
    // pathname we hydrate against always carries a trailing slash. Strip it
    // before matching, otherwise every one of these routes silently falls
    // through to the "home" branch right after hydration.
    const pathname =
      location.pathname.length > 1
        ? location.pathname.replace(/\/+$/, "")
        : location.pathname;

    if (
      pathname === "/waitlist" ||
      pathname === "/never-landing" ||
      pathname === "/likefatherlikeson" ||
      pathname === "/release"
    ) {
      setShowWaitlist(true);
      setCurrentPage("home");
    } else if (pathname === "/merch/terms" || pathname === "/merch/returns" || pathname === "/merch/privacy" || pathname === "/merch/withdrawal") {
      setShowWaitlist(false);
      setLegalKind(pathname.split("/").pop());
      setCurrentPage("legal");
    } else if (pathname === "/merch" || pathname.startsWith("/merch/")) {
      setShowWaitlist(false);
      setCurrentPage("merch");
    } else if (pathname === "/presskit") {
      setShowWaitlist(false);
      setCurrentPage("presskit");
    } else if (pathname === "/coming-soon") {
      setShowWaitlist(false);
      setCurrentPage("coming-soon");
    } else {
      setShowWaitlist(false);
      setCurrentPage("home");
    }
  }, [location]);

  useEffect(() => {
    // Signal that content is ready for prerendering
    setTimeout(() => {
      document.dispatchEvent(new Event("prerender-trigger"));
    }, 500);
  }, [currentPage]);

  const handleCloseModal = () => {
    setShowWaitlist(false);
    navigate("/"); // go back to homepage
  };

  // Handle navigation from Hero component mobile CTAs
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash === "#merch") {
        navigate("/merch");
      } else if (hash === "#shows") {
        // Scroll to shows section
        document
          .getElementById("shows")
          ?.scrollIntoView({ behavior: "smooth" });
      } else if (hash === "#booking") {
        // Scroll to booking section
        document
          .getElementById("booking")
          ?.scrollIntoView({ behavior: "smooth" });
      } else if (hash === "#discography") {
        document
          .getElementById("discography")
          ?.scrollIntoView({ behavior: "smooth" });
      }
    };

    // Check for hash in URL on initial load
    handleHashChange();

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, [navigate]);

  // Render different pages based on current route
  const renderCurrentPage = () => {
    switch (currentPage) {
      case "legal":
        return <LegalPage kind={legalKind} />;
      case "merch":
        return <Merch />;
      case "presskit":
        return <Presskit />;
      case "coming-soon":
        return <ComingSoon />;
      case "home":
      default:
        return (
          <>
            <Hero />
            <UpcomingShows />
            <AboutSection />
            <Discography />
            <BookingSection />
          </>
        );
    }
  };

  return (
    <div className="App dark-theme">
      <Navbar />
      {renderCurrentPage()}
      <Footer />
      <WaitlistModal show={showWaitlist} onClose={handleCloseModal} />
    </div>
  );
}

export default App;
